import axiosInstance from './axiosConfig';
import { AxiosResponse } from 'axios';
import { generateBFFUrl } from '@/configs/apiEndPoints';
import { ERROR } from '@/configs/constants';
import { GenericError } from '@/errors/GenericServerError';
import { BLOG_DETAIL, BLOG_PAGE, GET_ALL_BLOGS } from '@/configs/ecom/apis';
import dlv from 'dlv';
import seoResponseTransform from '@/utils/seoResponseTransform';

export const getCategoryBlogs = async (
  categoryId: string,
  pageSize?: number,
  page: number = 1,
): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(GET_ALL_BLOGS), {
      params: {
        populate: 'tags,desktopImage,mobileImage,blogType',
        blogTypeId: categoryId,
        pageSize,
        page,
      },
    });
    return response.data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const getAllBlogs = async (pageSize?: number, page: number = 1): Promise<any> => {
  try {
    const params = {
      populate: 'tags,desktopImage,mobileImage,blogType',
      pageSize,
      page,
    };

    const response = await axiosInstance.get(generateBFFUrl(GET_ALL_BLOGS), {
      params,
    });

    return response.data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const getBlogDetails = async (blogId: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(BLOG_DETAIL + blogId), {
      params: {
        ['populate[tags][populate]']: '*',
        ['populate[desktopImage][populate]']: '*',
        ['populate[mobileImage][populate]']: '*',
        'populate[seo][populate]': 'metaSocial.image,metaImage',
      },
    });
    const data = dlv(response, 'data.data.attributes', {});
    seoResponseTransform(data.seo);
    return data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const fetchBlogPage = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(BLOG_PAGE), {
      params: {
        'populate[seo][populate]': 'metaSocial.image,metaImage',
        'populate[layout][populate]': 'mobileImage,desktopImage',
      },
    });

    const data = dlv(response, 'data.data.attributes', {});

    seoResponseTransform(data.seo);
    return data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
